import { render, staticRenderFns } from "./Genesis.vue?vue&type=template&id=4c500cf1&"
import script from "./Genesis.vue?vue&type=script&lang=js&"
export * from "./Genesis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports